import styled, { css } from "styled-components";
import { Container } from "@material-ui/core";

const StyledController = styled(Container)`
  ${({ theme }) => {
    return css`
      overflow: hidden;
      width: 100vw;
      height: 100vh;
      background-color: #59656f;
      display: flex;
      padding: 10px 50px;
      text-align: center;
      font-family: 'Nunito', sans-serif;
      align-items: center;

      .MuiGrid-container {
        flex-wrap: nowrap;
      }

      .grid-item {
        margin-top: 12px;
        width: 100%;
      }


      .input-group {
        background: white;
        padding: 4px 8px;
        &:not(:first-child) {
          margin-left: 40px;
        }
      }
    `;
  }}
`;

export default StyledController;
